// FileUpload.tsx
import React from "react";
import "../text-input/styles.css"; // reuse same CSS
import Text from "../typography/text.js";
import RequiredIcon from "../../icons/required-icon.js";
import { Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const FileUpload = ({
  titleText,
  isRequired,
  helperText,
  errorText,
  isDisabled,
  placeholder = "Upload",
  parentClassName = "",
  className = "",
  fileName,                 // optional: pass current file name
  uploadProps = {},         // antd Upload props (fileList, onChange, etc)
}) => {
  // derive label from fileList if not passed explicitly
  const derivedName =
    fileName ||
    (uploadProps?.fileList?.[0]?.name ?? "");

  const hasValue = Boolean(derivedName);

  return (
    <div className={`text-input-container ${parentClassName} ${isDisabled ? "disabled" : ""}`}>
      <div className={isRequired ? "text-input-title" : ""}>
        <Text variant="tinyText">{titleText}</Text>
        {isRequired && <RequiredIcon />}
      </div>

      <div className={`text-input-box-container ${className}`}>
        {/* Make the entire "input" the trigger; no inner button */}
        <Upload
          disabled={isDisabled}
          showUploadList={false}
          beforeUpload={() => false}   // manual upload
          {...uploadProps}
          className="text-input-upload"
        >
          <div
            className={[
              "text-input-field",
              "text-input-upload-trigger",
              errorText ? "has-error" : "",
              hasValue ? "has-value" : "",
            ].join(" ")}
          >
            <UploadOutlined className="upload-icon" />
            <span className="file-label">
              {hasValue ? derivedName : placeholder}
            </span>
          </div>
        </Upload>
      </div>

      {helperText && (
        <Text variant="tinyText" color="lightText">
          {helperText}
        </Text>
      )}
      {errorText && (
        <Text variant="tinyText" color="failureColor">
          {errorText}
        </Text>
      )}
    </div>
  );
};

export default FileUpload;
